import React, { useEffect, useRef, useState } from "react";
import Banner from "../Banner/Banner";
import { useGetAllLatestNewsPublicQuery } from "../../Redux/getApi";
import { NavLink } from "react-router-dom";
import dayjs from "dayjs";
import { IoIosArrowDown } from "react-icons/io";

const HeroSection = () => {
  const { data: latestNewsData } = useGetAllLatestNewsPublicQuery({
    language: "urdu",
  });
  const originalData = latestNewsData?.latestNews || [];

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className=" flex lg:flex-row flex-col lg:pt-0  pt-14 items-stretch  ">
      <div
        ref={dropdownRef}
        className="w-40 lg:hidden block ml-auto xl:mr-[5%] lg:mr-[3%] mr-[2%] lg:my-6 my-4 rounded-2xl overflow-hidden absolute top-14 right-0 z-50"
      >
        {/* Header */}
        <div
          onClick={() => setOpen(!open)}
          className="cursor-pointer text-white bg-[#00643B] py-2 flex items-center justify-between px-2 gap-3 w-full font-medium"
        >
          Latest
          <IoIosArrowDown
            className={`transition-transform duration-300 ${
              open ? "rotate-180" : ""
            }`}
          />
        
        </div>

        {/* Dropdown */}
        {open && ( 
          <>
            {isNaN(originalData?.length) || originalData?.length === 0 ? (
              <div className=" flex items-center justify-center border bg-white border-[#0000001A] rounded-b-2xl gap-3 px-2 py-6">
                <p className="text-gray-500 text-sm">کوئی خبر نہیں ملی</p>
              </div>
            ) : (
              <div className=" w-full bg-white border border-[#0000001A] flex flex-col rounded-b-2xl gap-3 px-2 max-h-[400px] py-3 shadow-lg z-50">
                {/* Scrollable news */}
                <div className="overflow-y-auto w-full flex flex-col gap-2 text-right">
                  {originalData?.map((news, i) => (
                    <NavLink
                      to={news?.doc?.docUrl ? news.doc.docUrl : "/"}
                      target="_blank"
                      key={i}
                      className="border-b py-1 flex items-start justify-end gap-2"
                    >
                      {/* <p className="text-[0.7rem] whitespace-nowrap">
                        {dayjs(news.createdAt).format("D MMM")} |
                      </p> */}

                      <h2 className="text-[0.7rem] font-urdu font-medium text-[#00643B]  leading-[2.1]">
                        {news?.title}
                      </h2>
                    </NavLink>
                  ))}
                </div>

                {/* Button */}
                <NavLink
                  to={"/latest-news"}
                  className="p-2 px-4 rounded-lg w-max text-[0.8rem] bg-[#00643B] text-white"
                >
                  Read more
                </NavLink>
              </div>
            )}
          </>
         )}
      </div>
      <div className="lg:w-[75%] w-full">
        <Banner />
      </div>
      <div className=" hidden lg:block w-[25%] xl:mr-[5%] lg:mr-[3%] mr-[2%] lg:my-6 my-4 rounded-2xl overflow-hidden ">
        <div className="text-white 2xl:text-[2rem] xl:text-[1.5rem] text-lg bg-[#00643B] 2xl:py-4 xl:py-3 py-2 flex items-center justify-center w-full font-medium">
         Latest
        </div>
        {isNaN(originalData?.length) || originalData?.length === 0 ? (
          <div className="flex items-center justify-center border bg-white  border-[#0000001A]  rounded-b-2xl  gap-3 2xl:px-4 xl:px-3 px-2  py-10">
            <p className="text-gray-500 text-lg">کوئی خبر نہیں ملی</p>
          </div>
        ) : (
          <div className=" bg-white border border-[#0000001A] flex flex-col rounded-b-2xl  gap-3 2xl:px-4 xl:px-3 px-2 max-h-[400px] py-3">
            <div className=" overflow-y-auto custom-scroll  w-full flex flex-col xl:gap-3 gap-1  text-right">
              {originalData?.map((news, i) => (
                <NavLink
                 to={news?.doc?.docUrl ? news.doc.docUrl : "/"}
                  key={i}
                      target="_blank"

                  className="border-b-2 border-[#00643B80] py-1 flex items-start justify-end gap-2"
                >
                  {/* Date */}
                  {/* <p className="2xl:text-[0.9rem] xl:text-[0.8rem] text-[0.7rem] text-black whitespace-nowrap">
                    {dayjs(news.createdAt).format("D MMM")} |
                  </p> */}

                  {/* Title */}
                  <h2 className="2xl:text-[1rem] font-urdu xl:text-[0.8rem] text-[0.7rem] font-medium text-[#00643B]  leading-[2.1]">
                    {news?.title}
                  </h2>
                </NavLink>
              ))}
            </div>
            <NavLink
              to={"/latest-news"}
              className=" p-2 px-4 rounded-lg w-max 2xl:text-[1rem] text-[0.8rem] bg-[#00643B] text-white "
            >
              Read more
            </NavLink>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeroSection;
